import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import { ReduxDispatch } from '../../models/ReduxProps';
import { ProductDetailsModel, ProductModel } from '../models/ProductModel';
import * as ActionUtility from "../../utilities/ActionUtility";
import IStore from '../../models/IStore';
import ProductEffect from '../effects/productEffect';

type ActionUnion =
  void
  | HttpErrorResponseModel
  | ProductModel
  | String
  | Blob;

export default class ProductActions {
  public static readonly  REQUEST_GET_PRODUCT_LIST = 'ProductActions.REQUEST_GET_PRODUCT_LIST';
  public static readonly  REQUEST_GET_PRODUCT_LIST_FINISHED = 'ProductActions.REQUEST_GET_PRODUCT_LIST_FINISHED';

  public static readonly  REQUEST_POST_PRODUCT = 'ProductActions.REQUEST_POST_PRODUCT';
  public static readonly  REQUEST_POST_PRODUCT_FINISHED = 'ProductActions.REQUEST_POST_PRODUCT_FINISHED';

  public static readonly  REQUEST_DELETE_PRODUCT = 'ProductActions.REQUEST_DELETE_PRODUCT';
  public static readonly  REQUEST_DELETE_PRODUCT_FINISHED = 'ProductActions.REQUEST_DELETE_PRODUCT_FINISHED';

  public static readonly  REQUEST_PUT_PRODUCT = 'ProductActions.REQUEST_PUT_PRODUCT';
  public static readonly  REQUEST_PUT_PRODUCT_FINISHED = 'ProductActions.REQUEST_PUT_PRODUCT_FINISHED';

  public static readonly  REQUEST_GET_PRODUCT = 'ProductActions.REQUEST_GET_PRODUCT';
  public static readonly  REQUEST_GET_PRODUCT_FINISHED = 'ProductActions.REQUEST_GET_PRODUCT_FINISHED';

  public static readonly REQUEST_EXPORT_PRODUCT = 'ProductActions.REQUEST_EXPORT_PRODUCT';
  public static readonly REQUEST_EXPORT_PRODUCT_FINISHED = 'ProductActions.REQUEST_EXPORT_PRODUCT_FINISHED';


  public static getProductList = () : any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_GET_PRODUCT_LIST,
        ProductEffect.getProductList
      );
    };
  };
  public static createProduct = ( model:ProductDetailsModel):any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_POST_PRODUCT,
        ProductEffect.createProduct,
        model
      );
    };
  };

  public static deleteProduct = ( productId:string):any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_DELETE_PRODUCT,
        ProductEffect.deleteProduct,
        productId
      );
    };
  };

  //TODO: Handle case when product is not found
  public static getProduct = ( productId:string):any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_GET_PRODUCT,
        ProductEffect.getProduct,
        productId
      );
    };
  };

  public static updateProduct = (productData: ProductDetailsModel) => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_PUT_PRODUCT,
        ProductEffect.updateProduct,
        productData
      );
    };
  };

  public static exportProduct = ():any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ProductActions.REQUEST_EXPORT_PRODUCT,
        ProductEffect.exportProduct
      );
    };
  }
}